/**
 * فاصل ناعم بين بلوكات الصفحة الرئيسية.
 * مسافة صغيرة + خط أفقى رفيع لمنع التلاصق البصري بين البلوكات.
 *
 * الخيارات:
 *  - `space`: حجم الفراغ (sm افتراضي / md / lg / xl) — الفراغ شفّاف فتظهر خلفية الصفحة.
 *  - `line`: إظهار الخط الرفيع (افتراضي true). اجعلها false لفراغ خالص.
 */
/**
 * مسافة واحدة موحَّدة لكلّ الفواصل — كلّ الأحجام تشير لنفس القيمة
 * حتّى لا يختلف الفراغ بين بلوكين وآخرين.
 */
const UNIFIED_SPACE = "py-[clamp(56px,9vw,104px)]";

const SPACE_CLASS = {
  sm: UNIFIED_SPACE,
  md: UNIFIED_SPACE,
  lg: UNIFIED_SPACE,
  xl: UNIFIED_SPACE,
} as const;


export function HomeBlockDivider({
  space = "sm",
  line = true,
}: {
  space?: keyof typeof SPACE_CLASS;
  line?: boolean;
}) {
  return (
    <div className={`w-full bg-transparent ${SPACE_CLASS[space]}`} aria-hidden="true">
      {line ? (
        <div className="mx-auto w-full max-w-[1100px] px-6 sm:px-8">
          <div className="h-px w-full bg-foreground/80" />
        </div>
      ) : null}
    </div>
  );
}
